import useRequest from '@gp/hooks/useRequest';
import { getScheduleList } from '@gp/services/overview';
import moment from 'moment';
import { useMemo } from 'react';
import { filterCalendarHasTimeChange, getCommonCalendarList } from '../utils';

/**
 * 如果有当前时间点数据时，把当前时间点的未来数据放前面
 * @param dateType 时间粒度
 * @param calendarDataList 日历数据
 * @returns 日历数据
 */
const formatCalendarData = (dateType: ScheduledateTypes, calendarDataList: any): any | null => {
  if (!Array.isArray(calendarDataList) || !calendarDataList.length) return null;
  const result: CommonCalendarDataTypes = [];
  const currentTimeStart = moment().startOf(dateType).format('YYYY-MM-DD');
  const currentTimeEnd = moment().endOf(dateType).format('YYYY-MM-DD');
  for (const calendarDataItem of calendarDataList) {
    const { date, list } = calendarDataItem || {};
    const isCurrentTime = moment(date || '').isBetween(
      currentTimeStart,
      currentTimeEnd,
      null,
      '[]',
    );
    let newList: any[] = list;
    // 把当前时间点的未来数据放前面
    if (isCurrentTime && Array.isArray(newList)) {
      const currentTimeBeforeList = [];
      const currentTimeAfterList = [];
      for (const newItem of newList) {
        if (newItem?.isExpire) {
          currentTimeBeforeList.push(newItem);
        } else {
          currentTimeAfterList.push(newItem);
        }
      }
      newList = [...currentTimeAfterList, ...currentTimeBeforeList];
    }

    result.push({
      ...calendarDataItem,
      list: !Array.isArray(newList) || !newList.length ? null : newList,
    });
  }

  return result;
};

/**
 * 根据图例过滤日历数据
 * @param timeChange 是否打开time change开关
 * @param calendarDataList 日历数据
 * @returns 日历数据
 */
const filterCalendarData = (
  timeChange: boolean,
  calendarDataList: CommonCalendarDataTypes,
  category?: any,
): CommonCalendarDataTypes | null => {
  if (!Array.isArray(calendarDataList) || !calendarDataList.length) return null;
  if (calendarDataList.every((calendarDataItem) => !calendarDataItem?.list?.length)) return null;

  // 正常过滤数据
  const result: CommonCalendarDataTypes = [];
  for (const calendarDataItem of calendarDataList) {
    let calendarDataItemList = !timeChange
      ? calendarDataItem?.list
      : filterCalendarHasTimeChange(calendarDataItem?.list);
    if (category?.length) {
      const tempList = calendarDataItemList || [];
      const listTemp = [...tempList];
      calendarDataItemList = listTemp?.filter((item: any) => {
        return category?.includes(item.category);
      });
      // calendarDataItemList = calendarDataItemList?.filter((item: any) => {
      //   if (category?.includes('others')) {
      //     if (item.category) {
      //       return category?.includes(item.category);
      //     }
      //     return true;
      //   }
      //   return category?.includes(item.category);
      // });
    }
    result.push({
      ...calendarDataItem,
      list:
        !Array.isArray(calendarDataItemList) || !calendarDataItemList.length
          ? null
          : calendarDataItemList,
    });
  }

  // 过滤后如果list全是null
  if (result.every((item) => !item?.list?.length) && !category?.length) return null;
  return result;
};

export default function useCalendar(props: any) {
  const { timeChange, filter, category = [] } = props;
  const { composedDatePicker } = filter || {};
  const { granularity } = composedDatePicker || {};

  const {
    loading: calendarDataLoading,
    data: calendarData,
    run: getScheduleDataRun,
    runAsync: getScheduleDataRunAsync,
    cancel: getScheduleDataCancel,
  } = useRequest(getScheduleList, {
    manual: true,
  });

  const calendarDataFiltered = useMemo<CommonCalendarDataTypes>(() => {
    const list = getCommonCalendarList(calendarData as any);
    const listFormatted = formatCalendarData(granularity, list);
    const resDatas = filterCalendarData(timeChange, listFormatted, category);
    return resDatas || [];
  }, [timeChange, granularity, calendarData, category]);

  return {
    calendarDataLoading,
    calendarDataFiltered,
    getScheduleDataRun,
    getScheduleDataRunAsync,
    getScheduleDataCancel,
  };
}
